import { pushToDataLayer } from "../pushToDatalayer";

/**
 * Track events on the cart page. These include:
 * - Change quantity of product
 * - Remove product from cart
 * - Click on 'request cart'
 * - Clicks on 'view cart'
 *
 * @returns {void}
 */
function initCartTracking() {
  trackCartPageEvents();
  trackViewCart();
}

/**
 * Track events on the cart page. These include:
 * - Change quantity of product
 * - Remove product from cart
 * - Click on 'request cart'
 *
 * @returns {void}
 */
function trackCartPageEvents() {
  const cart = document.querySelector(".cart__row");
  if (!cart) return;

  /**
   * Track quantity change of products in the cart.
   *
   * @returns {void}
   */
  function trackQuantityChange() {
    const quantityInputs = cart.querySelectorAll(".cart__item-actions input");
    quantityInputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        const row = e.target.closest("tr");
        const title = row.querySelector(
          "td[data-title='Item Description']"
        ).textContent;

        pushToDataLayer("cart", {
          eventCategory: "cart",
          eventAction: "change",
          eventLabel: "quantity",
          eventValue: `${title} | Quantity: ${e.target.value}`,
        });
      });
    });
  }

  /**
   * Track removal of products from the cart.
   *
   * @returns {void}
   */
  function trackRemoveProduct() {
    const removeButtons = cart.querySelectorAll(
      ".cart__item-actions .cart__remove-item"
    );
    removeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        const row = e.target.closest("tr");
        const title = row.querySelector(
          "td[data-title='Item Description']"
        ).textContent;

        pushToDataLayer("cart", {
          eventCategory: "cart",
          eventAction: "click",
          eventLabel: "remove product",
          eventValue: `${title}`,
        });
      });
    });
  }

  /**
   * Track clicks on 'request cart' button
   *
   * @returns {void}
   */
  function trackRequestCart() {
    const requestCart = document.querySelector(".cart__submit-btn");
    if (!requestCart) return;

    requestCart.addEventListener("click", () => {
      pushToDataLayer("cart", {
        eventCategory: "cart",
        eventAction: "click",
        eventLabel: "request cart",
      });
    });
  }

  trackQuantityChange();
  trackRemoveProduct();
  trackRequestCart();
}

/**
 * Track clicks on 'view cart' button
 *
 * @returns {void}
 */
function trackViewCart() {
  const viewCart = document.querySelector(".header-vts__cart");
  if (!viewCart) return;

  viewCart.addEventListener("click", () => {
    pushToDataLayer("cart", {
      eventCategory: "global",
      eventAction: "click",
      eventLabel: "view cart",
    });
  });
}

function trackSnackbarViewcart() {
  const snackbar = document.querySelector(".mdc-snackbar a");
  if (!snackbar) return;

  snackbar.addEventListener("click", (e) => {
    pushToDataLayer("cart", {
      eventCategory: "snackbar",
      eventAction: "click",
      eventLabel: "view cart",
    });
  });
}

export { initCartTracking, trackSnackbarViewcart };
